import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

// Importing custom State modules
import global from "./modules/global";
import user from "./modules/user";
import stepper from "./modules/stepper";
import personalDetails from "./modules/personal_details";
import employmentDetails from "./modules/employment_details";
import investmentExperience from "./modules/investment_experience";
import investmentObjectives from "./modules/investment_objectives";
import financialCircumstances from "./modules/financial_circumstances";
import bankingDetails from "./modules/banking_details";
import declaration from "./modules/declaration";
import legalDocumentation from "./modules/legal_documentation";
import submissions from "./modules/submissions";

Vue.use(Vuex);

// Include static Store modules here that are core to the app. Dynamic ones are registered in respective Vue components
export default new Vuex.Store({
    modules: {
        global,
        user,
        stepper,
        personalDetails,
        employmentDetails,
        investmentExperience,
        investmentObjectives,
        financialCircumstances,
        bankingDetails,
        declaration,
        legalDocumentation,
        submissions
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
            paths: [
                "user",
                "submissions"
            ],
        }),
    ],
});
